import { createContext, FC, useState } from 'react';
import { ResponseCompanyParams } from '../../models/company';
import { ContainerSortingFields, Order } from '../../models/types';
import { ResponseDistrictParams } from '../../models/district';
import { ListContainerGroupResponseParams } from '../../models/container';

interface IContainersContext {
  containersUpdate: boolean;
  toggleContainersUpdate: () => void;
  containersCompaniesUpdate: boolean;
  toggleContainersCompaniesUpdate: () => void;
  containerGroups: ListContainerGroupResponseParams[];
  setContainerGroups: (val: ListContainerGroupResponseParams[]) => void;
  districts: ResponseDistrictParams[];
  setDistricts: (val: ResponseDistrictParams[]) => void;
  companies: ResponseCompanyParams[];
  setCompanies: (val: ResponseCompanyParams[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: keyof ContainerSortingFields;
  setOrderBy: (val: keyof ContainerSortingFields) => void;
  setContainersLoading: (val: boolean) => void;
  setDistrictsLoading: (val: boolean) => void;
  setCompaniesLoading: (val: boolean) => void;
  filterCompany: ResponseCompanyParams;
  setFilterCompany: (val: ResponseCompanyParams) => void;
  filterDistrict: ResponseDistrictParams;
  setFilterDistrict: (val: ResponseDistrictParams) => void;
  loading: boolean;
}

export const ContainersContext = createContext<IContainersContext>(
  {} as IContainersContext
);

export const ContainersProvider: FC = ({ children }) => {
  // Update
  const [containersUpdate, setContainersUpdate] = useState(false);
  const [containersCompaniesUpdate, setContainersCompaniesUpdate] = useState(false);

  // Data
  const [containerGroups, setContainerGroups] = useState<
    ListContainerGroupResponseParams[]
  >([]);
  const [districts, setDistricts] = useState<ResponseDistrictParams[]>([]);
  const [companies, setCompanies] = useState<ResponseCompanyParams[]>([]);

  // Filtering
  const [filterCompany, setFilterCompany] = useState<ResponseCompanyParams>(
    {} as ResponseCompanyParams
  );
  const [filterDistrict, setFilterDistrict] = useState<ResponseDistrictParams>(
    {} as ResponseDistrictParams
  );

  // Pagination props
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(5);
  const [count, setCount] = useState<number>(0);

  // Sorting
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] =
    useState<keyof ContainerSortingFields>('address');

  // Loading
  const [containersLoading, setContainersLoading] = useState(false);
  const [districtsLoading, setDistrictsLoading] = useState(false);
  const [companiesLoading, setCompaniesLoading] = useState(false);

  const loading = containersLoading || districtsLoading || companiesLoading;

  const toggleContainersUpdate = (): void =>
    setContainersUpdate(!containersUpdate);

  const toggleContainersCompaniesUpdate = (): void =>
    setContainersCompaniesUpdate(!containersCompaniesUpdate);

  return (
    <ContainersContext.Provider
      value={{
        containersUpdate,
        toggleContainersUpdate,
        toggleContainersCompaniesUpdate,
        containersCompaniesUpdate,
        containerGroups,
        setContainerGroups,
        districts,
        setDistricts,
        companies,
        setCompanies,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        setCompaniesLoading,
        setDistrictsLoading,
        setContainersLoading,
        filterCompany,
        setFilterCompany,
        filterDistrict,
        setFilterDistrict,
        loading
      }}
    >
      {children}
    </ContainersContext.Provider>
  );
};
